interface CiBarProps {
  estimate: number | null | undefined;
  lower: number | null | undefined;
  upper: number | null | undefined;
  min?: number;
  max?: number;
  unit?: string;
}

export function CiBar({
  estimate,
  lower,
  upper,
  min = -0.5,
  max = 0.5,
  unit = "",
}: CiBarProps) {
  if (estimate == null || lower == null || upper == null) {
    return <div style={{ color: "#9ca3af", fontSize: 12 }}>—</div>;
  }
  const range = max - min;
  const pct = (v: number) => `${(((v - min) / range) * 100).toFixed(1)}%`;
  const zeroPct = pct(0);
  const estPct = pct(Math.max(min, Math.min(max, estimate)));
  const loPct = pct(Math.max(min, Math.min(max, lower)));
  const ciWidth = `${(((Math.min(max, upper) - Math.max(min, lower)) / range) * 100).toFixed(1)}%`;

  return (
    <div style={{ userSelect: "none" }}>
      <div
        style={{
          position: "relative",
          height: 12,
          background: "#e5e7eb",
          borderRadius: 6,
          marginBottom: 4,
        }}
      >
        {/* zero line */}
        <div
          style={{
            position: "absolute",
            left: zeroPct,
            top: 0,
            bottom: 0,
            width: 2,
            background: "#9ca3af",
            transform: "translateX(-50%)",
          }}
        />
        {/* CI band */}
        <div
          style={{
            position: "absolute",
            left: loPct,
            width: ciWidth,
            top: 2,
            bottom: 2,
            background: estimate < 0 ? "#93c5fd" : "#fca5a5",
            borderRadius: 4,
            opacity: 0.7,
          }}
        />
        {/* point estimate */}
        <div
          style={{
            position: "absolute",
            left: estPct,
            top: 0,
            bottom: 0,
            width: 3,
            background: estimate < 0 ? "#1d4ed8" : "#dc2626",
            borderRadius: 2,
            transform: "translateX(-50%)",
          }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#6b7280" }}>
        <span>{lower.toFixed(3)}{unit}</span>
        <span style={{ fontWeight: 600, color: estimate < 0 ? "#1d4ed8" : "#dc2626" }}>
          {estimate.toFixed(3)}{unit}
        </span>
        <span>{upper.toFixed(3)}{unit}</span>
      </div>
    </div>
  );
}
